<template>
    <div>
        <ceclam-header />
        <div class="container"  style="margin-top:30px; margin-bottom:20px;">
        <div class="row" style="margin-bottom:30px; background:#fff;">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <ceclam-pesquisa @estadoFooter="loadingFooter  = $event" />
            </div>
            <div class="col-md-1" ></div>
        </div>
        <br>
        <br>
        <br>
        </div>
       <br>
       <br>
        <div class="footer2" >
           <p style="margin-top:20px;"> Copyright LEFISC - Legislação Fiscal - Todos os Direitos Reservados </p>
        </div>
    </div>
</template>

<script>
   import header from '../shared/header';
   import pesquisa from '../components/ceclamPesquisa.vue';

    export default {
        components:{
          'ceclam-header': header,
          'ceclam-pesquisa': pesquisa
        },
        data(){
            return{
                loadingFooter:'footer2'
            }
        }
    }
</script>

<style scoped>
    .corpo{
        overflow: hidden;
        min-height: 100vh;
    }
    .footer{
        width: 100%;
        text-align: center;
        height: 65px;
        background: #fff;
        padding-top: 3px;
        
    }
     .footer2{
        position: absolute;
        bottom:0;
        width: 100%;
        text-align: center;
        height: 65px;
        background: #fff;
    }
</style>





// WEBPACK FOOTER //
// src/screens/home.vue